import { Jaw, ToothPerioDraft } from '@libs/ui-lib';
import { PerioExamTraversalStrategy, PerioJawConfigTuple, PerioTeethRecord } from './models';

export const UPPER_RIGHT_JAW_START_TOOTH_POSITION = 1;
export const LOWER_LEFT_JAW_START_TOOTH_POSITION = 17;
export const JAW_STARTING_TOOTH_MAP: Record<Jaw, number> = {
  lower: LOWER_LEFT_JAW_START_TOOTH_POSITION,
  upper: UPPER_RIGHT_JAW_START_TOOTH_POSITION,
};
export const TOOTH_COUNT = 32;
export const SIDE_TOOTH_COUNT = TOOTH_COUNT / 2;

export const perioExamJawConfigMap: Record<PerioExamTraversalStrategy, PerioJawConfigTuple> = {
  archWise: [
    {
      jaw: 'upper',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'upper',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
    {
      jaw: 'lower',
      side: 'buccal',
      reverseTraversalOrder: true,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'lingual',
      reverseTraversalOrder: false,
      visualDirection: 'left',
    },
  ],
  crossArchSnake: [
    {
      jaw: 'upper',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'upper',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
  ],
  crossArchSnakeReverse: [
    {
      jaw: 'lower',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
    {
      jaw: 'upper',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'upper',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
  ],
  buccalThenLingual: [
    {
      jaw: 'upper',
      side: 'buccal',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'buccal',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
    {
      jaw: 'upper',
      side: 'lingual',
      reverseTraversalOrder: false,
      visualDirection: 'right',
    },
    {
      jaw: 'lower',
      side: 'lingual',
      reverseTraversalOrder: true,
      visualDirection: 'left',
    },
  ],
};

export const emptyPerioTeethData: PerioTeethRecord = Array.from({ length: TOOTH_COUNT }).reduce(
  (acc: PerioTeethRecord, _, i) =>
    ({
      ...acc,
      [i + 1]: {
        position: i + 1,
        isDefaultTooth: false,
        treatments: [],
        perio: {
          buccal: {
            pocketDepth: {
              distal: null,
              central: null,
              mesial: null,
            },
            bleedingOnProbing: {
              distal: false,
              central: false,
              mesial: false,
            },
            suppuration: {
              distal: false,
              central: false,
              mesial: false,
            },
            clinicalAttachmentLoss: {
              distal: null,
              central: null,
              mesial: null,
            },
            furcation: {
              distal: null,
              central: null,
              mesial: null,
            },
            gingivalMargin: {
              distal: null,
              central: null,
              mesial: null,
            },
          },
          lingual: {
            pocketDepth: {
              distal: null,
              central: null,
              mesial: null,
            },
            bleedingOnProbing: {
              distal: false,
              central: false,
              mesial: false,
            },
            suppuration: {
              distal: false,
              central: false,
              mesial: false,
            },
            clinicalAttachmentLoss: {
              distal: null,
              central: null,
              mesial: null,
            },
            furcation: {
              distal: null,
              central: null,
              mesial: null,
            },
            gingivalMargin: {
              distal: null,
              central: null,
              mesial: null,
            },
          },
        },
        jaw: i + 1 <= SIDE_TOOTH_COUNT ? 'upper' : 'lower',
        boneLoss: 0,
        mobility: 0,
      },
    }) as ToothPerioDraft,
  {} satisfies PerioTeethRecord,
);
